import api from "../api/axios";
import { AxiosError } from "axios";

/**
 * Token stored in memory and localStorage
 */
let token: string = localStorage.getItem("token") || "";

/**
 * Update token both in memory and localStorage
 */
export const setToken = (newToken: string) => {
  token = newToken;
  localStorage.setItem("token", newToken);
};

/**
 * Returns Authorization headers for API calls
 */
export const getAuthHeaders = () => ({
  Authorization: `Bearer ${token}`,
});

/**
 * Makes an API request and automatically refreshes the token on 401 errors
 */
export const requestWithRefresh = async <T,>(
  requestFn: () => Promise<T>,
): Promise<T> => {
  try {
    return await requestFn();
  } catch (err: unknown) {
    const error = err as AxiosError;

    // Token expired → refresh and retry
    if (error.response?.status === 401) {
      try {
        const refreshRes = await api.post("api/auth/refresh");

        setToken(refreshRes.data.token); // update token globally
        return await requestFn(); // retry original request
      } catch (refreshErr: unknown) {
        const e = refreshErr as AxiosError;
        console.error("Token refresh failed:", e.response?.data || e.message);
        throw e;
      }
    }

    // Other errors
    console.error("API request failed:", error.response?.data || error.message);
    throw error;
  }
};
